import { render } from "./ranking.vue?vue&type=template&id=06ff5150&scoped=true"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"

import "./ranking.vue?vue&type=style&index=0&id=06ff5150&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ff5150"]])

export default __exports__